import auth from "../../middlewares/auth";
export const courseLearningRoute = [
  {
    path: '/lecture/course-learning/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/course_learning/CourseLearningList'),
    name: 'lecture_course_learning_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/course-learning/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/course_learning/CourseLearningForm'),
    name: 'lecture_course_learning_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/course-learning/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/course_learning/CourseLearningForm'),
    name: 'lecture_course_learning_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];